import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { SiteContentEditor } from './SiteContentEditor';
import { BannerManager } from './BannerManager';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function AdminSettings() {
  const [content, setContent] = useState(null);
  const [activeBanner, setActiveBanner] = useState(null);
  const [banners, setBanners] = useState([]);

  const refreshAll = async () => {
    try {
      const [contentRes, bannerRes, listRes] = await Promise.all([
        axios.get(`${API_URL}/api/site-content`),
        axios.get(`${API_URL}/api/banner/active`),
        axios.get(`${API_URL}/api/admin/banners`, { withCredentials: true }),
      ]);
      setContent(contentRes.data);
      setActiveBanner(bannerRes.data);
      setBanners(listRes.data || []);
    } catch (err) {
      if (process.env.NODE_ENV !== 'production') console.error(err);
      toast.error('Failed to load settings');
    }
  };

  useEffect(() => { refreshAll(); }, []);

  if (!content) {
    return (
      <div className="flex items-center justify-center py-12" data-testid="admin-settings-loading">
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="admin-settings">
      <SiteContentEditor initialContent={content} onSaved={refreshAll} />
      <BannerManager activeBanner={activeBanner} banners={banners} onChange={refreshAll} />
    </div>
  );
}
